import React, { useState } from "react";
import logoBorealis from "./assets/logoBorealis.svg";
import logoGlearning from "./assets/logoGlearning.svg";
import MobileScreenShare from "@material-ui/icons/MobileScreenShare";
import QRCode from "react-qr-code";

//Components
import Footer from "./components/Footer";
import Form from "./components/Form";
import Content from "./components/Content";
import "./App.css";

import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import * as messages from "./translations";
import { IntlProvider } from "react-intl";
import { LanguageSelector } from "./components/LanguageSelector";

const useStyles = makeStyles(() => ({
  languageSwitch: {
    background: "#ffffff",
    color: "#002D5A",
    borderRadius: "4px",
    padding: "1px 8px",
    "&:hover": {
      background: "#F4F4F4;",
    },
    "&:focus": {
      background: "#F4F4F4;",
    },
  },
  qrCodeOverlay: {
    textAlign: "center",
    display: "block",
    cursor: "pointer",
    zIndex: 1000,
    width: "100%",
    height: "100%",
    position: "absolute",
    margin: "0",
    paddingTop: "20%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
  },
}));

function App(props) {
  const classes = useStyles();
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [qrOpen, setQrOpen] = React.useState(false);

  return (
    <IntlProvider locale="en" messages={messages[selectedLanguage]}>
      <div className="App">
        <header className="App-header">
          <img src={logoBorealis} className="logo" alt="logo" />
          <img src={logoGlearning} className="logo" alt="logo" />
          <div className="middleHeaderGap" />
          <div className="languageSwitchContainer">
            <Button
              className={classes.languageSwitch}
              variant="contained"
              color="primary"
              size="small"
              startIcon={<MobileScreenShare />}
              onClick={() => setQrOpen(!qrOpen)}
            >
              QR Code
            </Button>
            <LanguageSelector
              currentLanguage={selectedLanguage}
              possibleLanguages={Object.keys(messages)}
              setNewLanguage={(newLanguage) => setSelectedLanguage(newLanguage)}
            />
          </div>
        </header>
        <main>
          <div className="welcome">
            <h2>
              <span> Welcome </span>
              <span className="greyText"> Welkom </span>
              <span className="darkBlueText"> Välkommen </span>
              <span className="greyText"> Tervetuloa </span>
              <span> Dobro došli </span>
              <span className="greyText"> Witamy </span>
            </h2>
            <h2>
              <span className="greyText"> Benvenuto </span>
              <span className="darkBlueText"> Willkommen </span>
              <span> Bienvenue </span>
              <span className="blueText"> Bem-vindo </span>
              <span className="greyText"> Добро пожаловать </span>
              <span> Üdvözöljük </span>
            </h2>
            <h2>
              <span className="greyText"> Bine ați venit </span>
              <span className="darkBlueText">Добре дошли </span>
              <span className="greyText"> Sveiki </span>
              <span className="blueText"> Tere tulemast </span>
              <span> Vitajte </span>
              <span className="darkBlueText"> Dobrodošli </span>
            </h2>
          </div>
          {qrOpen && (
            <div
              className={classes.qrCodeOverlay}
              onClick={() => setQrOpen(false)}
            >
              <QRCode value={window.location.href} />
            </div>
          )}
          <div className="layout">
            <Content />
            <Form orgId={props.orgId} />
          </div>
          <Footer />
        </main>
      </div>
    </IntlProvider>
  );
}

export default App;
